import $ from 'jquery';
import barba from '@barba/core';
import { gsap } from 'gsap';

import { $Elements, Classes, Durations, Elements, Events, HasBarba, HasWoocommerce, Links, pauseAnimations, resetAnimations } from '../global/constants';
import { disableBodyScroll, enableBodyScroll, replaceBodyClasses, scrollPosition, smoothScrollTo, wait, waitForImage, waitForVideo } from '../global/helpers';
import { initPageTransition } from './default';

// ---------- Initialisation ----------

if(HasBarba) {

	if(HasWoocommerce) {

		if(document.body.classList.contains('woocommerce-page')) {
			initPageTransition(Links.base);
		}
		else {
			initBarba();
			initPageTransition(Links.shop, false);
		}
	}
	else {
		initBarba();
	}
}

// ---------- Functions ----------

function initBarba() {

	barba.init({
		debug: false,
		timeout: 10000,
		prefetchIgnore: true,
		preventRunning: true,
		prevent: ({ el }) => !$(el).is(Links.barba),
		transitions: [{
			sync: true,
			once: async() => {
				$Elements.window.on('load', pageLoaded);
				$Elements.document.trigger(Events.page.loaded);
			},
			enter: async() => $Elements.document.one(Events.page.transition, pageLoaded),
			leave: async(data) => {
				Elements.MainWrapper.classList.remove(Classes.initialLoad);
				Elements.LoadingOverlay.classList.remove(Classes.initialLoad);

				Elements.LoadingBar.classList.add(Classes.loading);
				document.body.classList.add(Classes.leaving);

				pauseAnimations();

				if(isMenuLink(data)) {
					await menuImageTransition(data);
				}
				else {
					await defaultTransition(data);
				}

				return true;
			},
			after: async(data) => {

				smoothScrollTo(0, 0, 0);

				replaceBodyClasses(data.next);

				$('.' + Classes.transitionClone).remove();

				$Elements.document.trigger(Events.page.transition);

				return true;
			}
		}]
	});
}

// ---------- Global ----------

async function pageLoaded() {

	resetAnimations();
	$Elements.document.trigger(Events.page.enter);
	Elements.LoadingBar.classList.remove(Classes.loading);
	Elements.MainWrapper.classList.remove(Classes.loading);
	Elements.LoadingOverlay.classList.remove(Classes.loading);

	return true;
}

async function waitForPage(page = Elements.PageWrapper, duration = Durations.page.ms) {

	await wait(duration);
	const heroVideo = page.querySelector(`.${Classes.ContentWrapper} > .content-section:first-child .video`);
	const heroImage = page.querySelector(`.${Classes.ContentWrapper} > .content-section:first-child .image`);

	if(heroVideo) {
		await waitForVideo(heroVideo);
	}
	else if(heroImage) {
		await waitForImage(heroImage);
	}
	return true;
}

async function saveCurrentScrollPosition(data) {

	const scroll = scrollPosition();

	data.current.container.classList.add(Classes.leaving);
	data.current.container.style.top = -scroll.scrollTop + 'px';

	smoothScrollTo(0, 0, 0);

	return true;
}

// ---------- Menu Link Transition ----------

function isMenuLink(data) {
	return (typeof data.trigger !== 'string' && data.trigger.parentNode.classList.contains('hero-column'));
}

async function menuImageTransition(data) {

	const column = data.trigger;


	if(column) {

		await saveCurrentScrollPosition(data);

		disableBodyScroll();

		$(data.next.container).find('.menu-wrapper, .header-wrapper').addClass(Classes.hidden);
		$(data.next.container).find('.header-wrapper').addClass(Classes.shrink);

		$(column).find('.image').each(function() {
			$(this).attr('sizes', window.innerWidth + 'px');
		});

		const clone = document.createElement('div');
		clone.classList.add('content-column', 'image-column', 'hero-column', Classes.transitionClone);
		[...column.children].forEach(child => clone.appendChild(child));

		const bounds = column.getBoundingClientRect();

		gsap.set(clone, {
			top: bounds.top,
			left: bounds.left,
			width: bounds.width,
			height: bounds.height,
		});

		document.body.appendChild(clone);

		await gsap.to(clone, {
			top: 0,
			left: 0,
			width: '100%',
			height: '100vh',
			autoRound: false,
			duration: Durations.page.s,
		});

		const nextHero = data.next.container.querySelector('.hero-section .hero-column');

		document.body.classList.remove(Classes.menuOpen);

		data.current.container.classList.add(Classes.hidden);

		nextHero.replaceWith(clone);

		const h1 = $(clone).find('div.h1');
		h1.replaceWith('<h1>' + h1.html() + '</h1>');

		clone.classList.remove(Classes.transitionClone);

		$(data.next.container).find('.menu-wrapper, .header-wrapper').removeClass(Classes.hidden);
		await wait(50);
		$(data.next.container).find('.header-wrapper').removeClass(Classes.shrink);

		enableBodyScroll();
	}

	return true;
}

// ---------- Default Transition ----------

async function defaultTransition(data) {

	Elements.LoadingOverlay.classList.add(Classes.loading);

	await saveCurrentScrollPosition(data);

	disableBodyScroll();

	if(document.body.classList.contains(Classes.menuOpen)) {
		document.body.classList.remove(Classes.menuOpen);
	}

	await waitForPage(data.next.container);

	enableBodyScroll();

	return true;
}
